<template>
    <div class="l-container-content">
        <div class="row" v-show="role==2 || role==3 " >
            <div class="col-6">
                <div class="text-title">
                    <h2 class="text-medium">Resulting</h2>
                </div>
            </div>
            <div class="col-6 text-right">

                <div class="l-input inline">
                    <i class=" search icon"></i>
                    <input v-on:keyup.enter="searchMatches" @input="onSearchInput" type="text" placeholder="Search..." v-model="search_match">
                </div>
                <div class="l-input inline">
                    <i class="icon-calendar"></i>
                    <input name="dates" placeholder="Choose date" />
                </div>
            </div>
        </div>
        <div class="row">
            <div id="table-wrapper" style="position:relative">
                <loader v-show='loading' />
                <div v-show="replayAllLoading" class="replay-all-overlay">
                    <div class="replay-all-spinner"></div>
                    <div class="replay-all-text">Replaying {{replayAllDoneCount}} / {{replayAllTotalCount}}</div>
                </div>

                <button  v-if="((role == 2 || role==3))" class="ui aligned-left green button" @click="reloadResulting">Refresh Resulting</button>
                <button
                    v-if="(role == 2 || role == 3)"
                    class="ui aligned-left button"
                    @click="refreshTable"
                    style="margin-left: .5rem;"
                >
                    <i class="sync icon"></i>
                    Refresh Table
                </button>
                <button
                    v-if="(role == 2 || role == 3) && perPage !== totalResults && totalResults > perPageDefault"
                    class="ui aligned-left button"
                    @click="fetchAllResults"
                    style="margin-left: .5rem;"
                >
                    <i class="download icon"></i>
                    Fetch All Results
                </button>
                <button
                    v-if="(role == 2 || role == 3) && perPage === totalResults && totalResults > perPageDefault"
                    class="ui aligned-left button"
                    @click="resetPagination"
                    style="margin-left: .5rem;"
                >
                    <i class="list icon"></i>
                    Show Paginated
                </button>

                <button
                    v-if="(role == 2 || role == 3) && totalResults > 0"
                    class="ui aligned-left blue button"
                    :disabled="replayAllLoading"
                    @click="replayAllMatches"
                    style="margin-left: .5rem;"
                >
                    <i class="blue refresh icon"></i>
                    Replay All Matches
                </button>


                <vuetable ref="vuetable"
                      :api-url="vueurl"
                      :fields="columns"
                      :detail-row-component="detailRow"
                      :sort-order="sortOrder"
                      track-by="parent_match_id"
                      :append-params="moreParams"
                      :per-page="perPage"
                      detail-row-component="my-detail-row"
                      @vuetable:cell-clicked="onCellClicked"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loading="onLoading"
                      @vuetable:loaded="onLoaded"
            >

                <div slot="Result" slot-scope="props">
                    <button
                            class="ui green button"
                            @click="onActionClicked('view-item', props.rowData)"
                    >
                        <i class="zoom icon"></i>
                    </button>

                    <button
                            class="ui red button"
                            @click="onActionVoid('view-item', props.rowData)"
                    >
                        <i class="zoom icon"></i>
                    </button>

                    <button
                            class="ui button"
                            :class="{ loading: replayAllLoading || isReplayLoading(props.rowData.parent_match_id) }"
                            :disabled="replayAllLoading || isReplayLoading(props.rowData.parent_match_id)"
                            title="Replay producers 1 & 3"
                            @click="replayFeed(props.rowData)"
                    >
                        <i class="blue refresh icon"></i>
                    </button>
                </div>
            </vuetable>

            </div>

            <div class="vuetable-pagination ui basic segment grid">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
                <vuetable-pagination ref="pagination"
                                     @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
            </div>

        </div>

        <modalResulting v-if="selected_data" :data="selected_data"/>

    </div>
</template>

<script>
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
    import MyDetailRow from "../components/resultingModal";
    import loader from "@/components/loader"
    import modalResulting from "../components/resultingModal";
    import XLSX from 'xlsx';
    import {config} from '../config/config';

    export default {
        components: {
            Vuetable, VuetablePagination, VuetablePaginationInfo, MyDetailRow, loader,modalResulting,XLSX,config
        },
        name: 'resulting',

        data() {
            return {
                vueurl:config.baseURL+'portal/pending/matches',
                columns: [

                    // {
                    //     name: 'parent_match_id',
                    //     title: '#',
                    //     dataClass: 'center aligned',
                    //     callback: 'showDetailRow'
                    // },
                    {
                        name: 'parent_match_id',
                        title: 'MatchID',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned',
                        sortField: 'parent_match_id',
                       // callback: 'showDetailRow'
                    },
                    {
                        name: 'home_team',
                        title: 'Home',
                        sortField: 'home_team'
                    },
                    {
                        name: 'away_team',
                        title: 'Away',
                        sortField: 'away_team'
                    },
                    {
                        name: 'start_time',
                        title: 'Start Time',
                        sortField: 'start_time',
                        callback: 'createdAt'
                    },
                    {
                        name: 'sport_name',
                        title: 'Sport',
                        sortField: 'sport_name'
                    },
                    {
                        name: 'bets',
                        title: 'Bets',
                        dataClass: 'center aligned',
                        sortField: 'bets'
                    },
                    {
                        name: 'result',
                        dataClass: 'center aligned',
                        title: 'Result'
                    },

                    'Result'
                ],

                detailRow: MyDetailRow,
                loading: true,
                prevRoute: '',
                range:'',
                is_partial_resulting:false,
                search_match:'',
                searchDebounceTimer: null,
                replayLoadingByMatchId: {},
                replayAllLoading: false,
                replayAllDoneCount: 0,
                replayAllTotalCount: 0,
                replayAllPendingAfterReload: false,
                perPageDefault: 10,
                perPage: 10,
                totalResults: 0,
                loadOnStart: true,
                sortOrder: [{
                    field: 'modified',
                    direction: 'asc'
                }],
                user_id:'',
                role:'',
                token:'',
                moreParams: {
                    start: '',
                    filter: '',
                    end: '',
                    token:this.token,
                },
                sport_id: 1,
                selected_data: {},
                css: {
                    table: {
                        tableClass: 'table table-striped table-bordered table-hovered',
                        loadingClass: 'loading',
                        ascendingIcon: 'glyphicon glyphicon-chevron-up',
                        descendingIcon: 'glyphicon glyphicon-chevron-down',
                        handleIcon: 'glyphicon glyphicon-menu-hamburger',
                    },
                    pagination: {
                        infoClass: 'pull-left',
                        wrapperClass: 'vuetable-pagination pull-right',
                        activeClass: 'btn-primary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        },
                    }
                }

            }
        },




        mounted(){
            //var headerHeight = document.getElementById('header').offsetHeight;
            //document.getElementById('main-content').style.top = headerHeight + 'px';

            var vm = this;


            var obj = window.localStorage.getItem('user_info');
            var jsonData = JSON.parse(obj);
            var rolee=jsonData.role;
            var userr=jsonData.id;


            vm.role=rolee;
            vm.user_id=userr;
            vm.token=jsonData.token;;

            if((vm.role  !=2 && vm.role !=3)){

                vm.$router.push({name: 'login'});
            }

            var start = moment();
            var end = moment();

            function cb(start, end) {
                vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                $('input[name="dates"]').val(start.format('D MMMM, YYYY') + ' - ' + end.format('D MMMM, YYYY'));
            }



            $('input[name="dates"]').daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }
            }, cb);

            cb(start, end);



        },

        beforeCreate: function () {
            var vm=this;


            const itemStr = localStorage.getItem("timer")
            // if the item doesn't exist, return null
            if (!itemStr) {
                return null
            }
            const item = itemStr

            var checktimer = new Date(item);

            const now = new Date()
            // compare the expiry time of the item with the current time
            if (now.getTime() > checktimer.getTime()) {
                // If the item is expired, delete the item from storage
                // and return null
                localStorage.removeItem("timer");
                localStorage.removeItem("user_info");


                const Toast = vm.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 9000
                });
                Toast.fire({
                    type: 'error',
                    title: "Your session expired, Please login again "
                })

                vm.$router.push({name: 'login'});
                return null
            }


        },


        created: function () {
        },

        methods: {

            checktimer:function(){
                var vm=this;
                const itemStr = localStorage.getItem("timer")
                // if the item doesn't exist, return null
                if (!itemStr) {
                    return null
                }
                const item = itemStr

                var checktimer = new Date(item);

                const now = new Date()
                // compare the expiry time of the item with the current time
                if (now.getTime() > checktimer.getTime()) {
                    // If the item is expired, delete the item from storage
                    // and return null
                    localStorage.removeItem("timer");
                    localStorage.removeItem("user_info");

                    const Toast = vm.$swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 9000
                    });
                    Toast.fire({
                        type: 'error',
                        title: "Your session expired, Please login again "
                    })

                    vm.$router.push({name: 'login'});
                    return null
                }

            },

            onLoading() {
                this.loading = true

            },
            onLoaded() {
                this.loading = false

                if (this.replayAllPendingAfterReload) {
                    this.replayAllPendingAfterReload = false
                    this.replayAllMatches(true)
                }
            },

            dateFilter: function (start, end) {

                var vm = this;


                vm.start = start;
                vm.end = end;


                vm.moreParams.start = start;
                vm.moreParams.end = end;
                vm.moreParams.token = vm.token;

                this.$refs.vuetable.reload();


            },

            searchMatches:function(){
                this.moreParams.filter = this.search_match;
                this.$refs.vuetable.reload();
            },

            onSearchInput: function () {
                var vm = this;
                if (vm.searchDebounceTimer) {
                    clearTimeout(vm.searchDebounceTimer);
                }
                vm.searchDebounceTimer = setTimeout(function () {
                    vm.searchMatches();
                }, 350);
            },

            isReplayLoading: function (matchId) {
                return !!this.replayLoadingByMatchId[matchId];
            },

            getRowsForReplayAll: function () {
                const vuetable = this.$refs && this.$refs.vuetable ? this.$refs.vuetable : null
                if (!vuetable) return []

                if (Array.isArray(vuetable.tableData)) return vuetable.tableData
                if (vuetable.tableData && Array.isArray(vuetable.tableData.data)) return vuetable.tableData.data
                if (Array.isArray(vuetable.data)) return vuetable.data
                if (vuetable.data && Array.isArray(vuetable.data.data)) return vuetable.data.data
                if (Array.isArray(vuetable.filteredData)) return vuetable.filteredData

                return []
            },

            replayAllMatches: async function (force) {
                // `force=true` is used when we re-run after `fetchAllResults()` reloads the table.
                if (this.replayAllLoading && !force) return

                const vm = this
                vm.replayAllLoading = true
                vm.replayAllDoneCount = 0
                vm.replayAllTotalCount = 0

                try {
                    if (!force && vm.perPage !== vm.totalResults) {
                        vm.replayAllPendingAfterReload = true
                        vm.fetchAllResults()
                        return
                    }

                    vm.replayAllPendingAfterReload = false

                    const rows = vm.getRowsForReplayAll()
                    const matchIds = Array.from(new Set(
                        (rows || [])
                            .map(r => r && r.parent_match_id)
                            .filter(id => id !== undefined && id !== null && id !== '')
                    ))

                    vm.replayAllTotalCount = matchIds.length

                    if (vm.replayAllTotalCount === 0) {
                        vm.replayAllLoading = false
                        vm.$swal("Info!", "No matches loaded to replay. Try Fetch All Results first.", "info")
                        return
                    }

                    for (let idx = 0; idx < matchIds.length; idx++) {
                        const matchId = matchIds[idx]

                        vm.$set(vm.replayLoadingByMatchId, matchId, true)

                        await Promise.allSettled([
                            vm.postReplay(matchId, 1),
                            vm.postReplay(matchId, 3)
                        ])

                        vm.$set(vm.replayLoadingByMatchId, matchId, false)
                        vm.replayAllDoneCount = idx + 1
                    }

                    vm.replayAllLoading = false
                    vm.$swal("Success!", "Replay triggered for " + vm.replayAllDoneCount + " matches.", "success")
                } catch (e) {
                    vm.replayAllLoading = false
                    vm.replayAllPendingAfterReload = false
                    vm.$swal("Error!", "Replay all failed: " + (e && e.message ? e.message : "Unknown error"), "error")
                }
            },

            postReplay: function (matchId, producerId) {
                var matchUrn = 'sr:match:' + matchId;
                var url = config.replayBaseURL + "/v1/"+'replay/' + matchUrn + '/' + producerId;

                // CORS note:
                // The replay service doesn't provide `Access-Control-Allow-Origin`, so XHR/$.ajax will fail in-browser.
                // `fetch(..., { mode: 'no-cors' })` still sends the request, but the response is not readable.
                // We treat "request reachable" as success (fire-and-forget).
                return fetch(url, { method: 'POST', mode: 'no-cors' })
                    .then(function () {
                        return { producerId: producerId, ok: true };
                    })
                    .catch(function (err) {
                        throw { producerId: producerId, ok: false, error: err };
                    });
            },

            replayFeed: function (row) {
                var vm = this;
                var matchId = row && row.parent_match_id ? row.parent_match_id : null;
                if (!matchId) {
                    vm.$swal("Error!", "Missing match id (parent_match_id).", "error");
                    return;
                }

                if (vm.isReplayLoading(matchId)) {
                    return;
                }

                vm.$swal.fire({
                    title: 'Replay feed?',
                    text: 'Replay producers 1 (LiveOdds) and 3 (Ctrl) for MatchID ' + matchId + '?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Replay!'
                }).then(function (result) {
                    if (!result.value) {
                        return;
                    }

                    vm.$set(vm.replayLoadingByMatchId, matchId, true);

                    Promise.allSettled([vm.postReplay(matchId, 1), vm.postReplay(matchId, 3)])
                        .then(function (results) {
                            var ok = [];
                            var failed = [];

                            results.forEach(function (r) {
                                if (r.status === 'fulfilled') {
                                    ok.push(r.value.producerId);
                                } else {
                                    failed.push(r.reason && r.reason.producerId ? r.reason.producerId : '?');
                                }
                            });

                            if (failed.length === 0) {
                                vm.$swal("Success!", "Replay triggered for producers: " + ok.join(', '), "success");
                            } else if (ok.length === 0) {
                                vm.$swal("Error!", "Replay failed for producers: " + failed.join(', '), "error");
                            } else {
                                vm.$swal("Warning!", "Replay OK for: " + ok.join(', ') + ". Failed for: " + failed.join(', '), "warning");
                            }
                        })
                        .catch(function (e) {
                            vm.$swal("Error!", "Replay request failed: " + (e && e.error ? e.error : 'Unknown error'), "error");
                        })
                        .finally(function () {
                            vm.$set(vm.replayLoadingByMatchId, matchId, false);
                        });
                });
            },

            getsport: function () {
                var vm = this;

                var data = {
                    parent_match_id: vm.parent_match_id,
                    token:vm.token,

                };


                $.ajax({
                    url: config.baseURLWEB+'resulting/sports',
                    type: 'POST',
                    data: JSON.stringify(data),
                    success: function (response, textStatus, jQxhr) {

                        vm.sports_info = response.data;
                    },
                    error: function (jqXhr, textStatus, error) {

                        vm.$swal("Error!", error, "error");
                    }
                });
            },

            dataManager(sortOrder, pagination) {
                if (this.data.length < 1) return;

                let local = this.data;

                // sortOrder can be empty, so we have to check for that as well
                if (sortOrder.length > 0) {

                    local = _.orderBy(
                        local,
                        sortOrder[0].sortField,
                        sortOrder[0].direction
                    );
                }

                pagination = this.$refs.vuetable.makePagination(
                    local.length,
                    this.perPage
                );

                let from = pagination.from - 1;
                let to = from + this.perPage;

                return {
                    pagination: pagination,
                    data: _.slice(local, from, to)
                };
            },


            showDetailRow: function (value) {

                $(".ui.dropdown").dropdown();

              //   value._showDetails = !value._showDetails;
                // var icon = this.$refs.vuetable.isVisibleDetailRow(value) ? 'minus' : 'plus';
                // return [
                //     '<a class="show-detail-row">',
                //     '<i class=" circle ' + icon + ' icon"></i>',
                //     '</a>'
                // ].join('');

                this.$refs.vuetable.toggleDetailRow(value.parent_match_id)
            },

            // onCellClicked (data) {
            //     this.$refs.vuetable.toggleDetailRow(data.parent_match_id)
            //
            // },

            onCellClicked (data, field, event) {

                this.$refs.vuetable.toggleDetailRow(data.data.parent_match_id)
            },


            onPaginationData(paginationData) {
                this.totalResults = paginationData && paginationData.total ? paginationData.total : 0;
                this.$refs.paginationInfo.setPaginationData(paginationData)
                this.$refs.pagination.setPaginationData(paginationData)
            },


            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            onActionClicked(action, data) {


                this.selected_data=data

                $('#modal-resulting').modal("show");//.modal({centered: false}).modal("show");
            },

            reloadResulting(action, data) {

                var vm = this;
                vm.$swal.fire({
                    title: 'Refresh Resulting/Payouts?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Refresh!'
                }).then((result) => {

                    if (result.value) {
                        var Voiddata = {
                            user_id: vm.user_id,
                            token:vm.token,
                        };

                        $.ajax({
                            url: config.baseURLWEB+'payouts',
                            type: 'post',
                            data: JSON.stringify(Voiddata),
                            success: function (response, textStatus, jQxhr) {

                                if (response.status_code == 200) {
                                    vm.$swal("Success!", "Application Restarted", "success");

                                    $('#switch-modall').modal('hide');
                                } else {
                                    vm.$swal("Error!", response.status_description, "error");
                                }
                            },
                            error: function (jqXhr, textStatus, error) {

                                vm.$swal("Error!", error, "error");
                            }
                        });
                    }else {

                    }
                })
            },

            fetchAllResults: function () {
                var vm = this;
                if (!vm.totalResults || vm.totalResults <= vm.perPageDefault) {
                    return;
                }
                vm.perPage = vm.totalResults;
                vm.$refs.vuetable.changePage(1);
                vm.$refs.vuetable.reload();
            },

            resetPagination: function () {
                var vm = this;
                vm.perPage = vm.perPageDefault;
                vm.$refs.vuetable.changePage(1);
                vm.$refs.vuetable.reload();
            },

            refreshTable: function () {
                if (this.$refs && this.$refs.vuetable) {
                    this.$refs.vuetable.reload();
                }
            },

            onActionVoid(action, data) {

                var vm = this;

                if (action == 'view-item') {

                    vm.$swal({
                        title: "Match Voiding",
                        text: "If you are sure, type in the  Void Factor:",
                        input: 'text',
                        inputAttributes: {
                            autocapitalize: 'off'
                        },
                        showCancelButton: true,
                        confirmButtonText: 'Void Match',
                        showLoaderOnConfirm: true,
                        preConfirm: (priority) => {

                            if (!priority) {
                                return;
                            }
                            var Voiddata = {
                                parent_match_id: data.parent_match_id,
                                void_factor: priority,
                                user_id: vm.user_id,
                                token:vm.token,
                            };

                            $.ajax({
                                url: config.baseURLWEB+'odibets/voiding',
                                type: 'POST',
                                data: JSON.stringify(Voiddata),
                                success: function (response, textStatus, jQxhr) {

                                    if (response.status_code == 200) {
                                        vm.$swal("Success!", response.status_description, "success");

                                        $('#switch-modall').modal('hide');
                                    } else {
                                        vm.$swal("Error!", response.status_description, "error");
                                    }
                                },
                                error: function (jqXhr, textStatus, error) {

                                    vm.$swal("Error!", error, "error");
                                }
                            });
                        }
                    });

                } else {


                }
            }



        },


        watch: {
            data(newVal, oldVal) {
                this.$refs.vuetable.reload();
            },
            range(){

                var start = this.range[0];
                var end = this.range[1];
                start= moment(start).format('YYYY-MM-DD');
                end= moment(end).format('YYYY-MM-DD');
                this.moreParams.start = start;
                this.moreParams.end = end;
                this.moreParams.token = this.token;
                this.$refs.vuetable.reload();
            }
        },

    }

</script>

<style scoped>
.replay-all-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10001;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.7);
}

.replay-all-spinner {
    width: 50px;
    height: 50px;
    border: 7px solid #ccc;
    border-top: 7px solid #3498db;
    border-radius: 50%;
    animation: replay-all-spin 1.6s linear infinite;
    margin-bottom: 12px;
}

.replay-all-text {
    font-weight: 600;
    color: #000;
}

@keyframes replay-all-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>